import React, { Dispatch, ReactNode, SetStateAction } from 'react';
import { Button, Stack } from '@mui/material';
import { Download } from '@mui/icons-material';

import { exportOpportunityReportToCsv, GroupByValue } from './exportToCsv';
import { FullReportResponse, ReportListingFilterLabels, ReportsListingFilters } from '../../types';

interface Props {
  loading: boolean;
  groupNode: ReactNode;
  groupBy: GroupByValue;
  filters: ReportsListingFilters;
  list: FullReportResponse['list'];
  exportFilterLabels: ReportListingFilterLabels;
  setAllGroupsOpen: Dispatch<SetStateAction<boolean>>;
}

export const ReportActions = ({
  list,
  filters,
  loading,
  groupBy,
  groupNode,
  setAllGroupsOpen,
  exportFilterLabels,
}: Props) => {
  const handleExportCsv = () => {
    exportOpportunityReportToCsv(list, groupBy, filters, exportFilterLabels);
  };

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      {groupNode}

      <Stack direction="row" alignItems="center" gap="0.5rem">
        <Button size="small" variant="outlined" onClick={() => setAllGroupsOpen(true)}>
          Expand All
        </Button>

        <Button size="small" variant="outlined" onClick={() => setAllGroupsOpen(false)}>
          Collapse All
        </Button>

        <Button
          size="small"
          variant="outlined"
          startIcon={<Download />}
          onClick={handleExportCsv}
          disabled={!list.length || loading}
        >
          Export CSV
        </Button>
      </Stack>
    </Stack>
  );
};
